/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from 'purify-ts/Maybe';
import { coerceToString } from './string';
/* Split a string on whitespace. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
function split(str, opts = {}) {
    const s = opts?.caseInsensitive === true ? str.toLocaleLowerCase() : str;
    return s.split(/\s+/).filter(x => x !== '');
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Search {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(keys, options) {
        this.keys = keys;
        this.options = { ...Search.defaultOptions, ...options };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    search(query, items) {
        // TODO: More intelligent splitting of terms. Allow quoting to
        // represent a term containing whitespace? Search all keys except one/a
        // few?
        const terms = split(query).map(t => this.makeTerm(t));
        return items.filter(item => terms.every(term => term.keys.some(key => {
            const val = this.maybePrepareTerm(item[key]);
            return val.mapOrDefault(v => v.includes(term.q), false);
        })));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    makeTerm(query) {
        const colon = query.indexOf(':');
        if (colon !== -1) {
            // We get the key in this roundabout way to make typescript happy,
            // because this way it can infer that the key is actually one of
            // the searcher's allowed keys.
            const sliced = query.slice(0, colon);
            const key = this.keys.find(k => k === sliced);
            if (key != null) {
                return {
                    keys: [key],
                    q: this.prepareTerm(query.slice(colon + 1)),
                };
            }
        }
        return {
            keys: this.keys,
            q: this.prepareTerm(query),
        };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    prepareTerm(str) {
        if (this.options.caseInsensitive) {
            return str.toLocaleLowerCase();
        }
        else {
            return str;
        }
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    maybePrepareTerm(str) {
        const value = Maybe.isMaybe(str) ? str : Maybe.fromNullable(str);
        return value.map(coerceToString).map(val => this.prepareTerm(val));
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
Search.defaultOptions = {
    caseInsensitive: true,
};
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function filterMatchingWords(filter, subjects, opts = {}, 
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
mapper = x => x) {
    const filterTerms = split(filter, opts);
    return subjects.filter(subject => {
        const subjectTerms = split(mapper(subject), opts);
        return filterTerms.every(fTerm => subjectTerms.some(sTerm => sTerm.includes(fTerm)));
    });
}
